import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import type { EventGroupItem } from 'pages/Cms/event-list/utils'
import Headline from 'redesign/components/atoms/Headline'
import { HEADLINE_LEVELS } from 'redesign/components/atoms/Headline/constants'
import EventCard from '../event-card'
import { BodyContainer, Container } from './styles'

const EventsGroup: React.FC<EventGroupItem> = ({ dateLabel, contents, onClickCard }) => {
  const { t } = useFavurTranslation()

  return (
    <Container>
      <Headline text={t(dateLabel)} level={HEADLINE_LEVELS.second} />
      <BodyContainer>
        {contents.map((event) => (
          <EventCard key={event.uuid} event={event} onClick={onClickCard ? () => onClickCard(event) : undefined} />
        ))}
      </BodyContainer>
    </Container>
  )
}

export default EventsGroup
